import { gql } from "graphql-tag";

export const CREATE_FRIEND_REQUEST_SUBSCRIPTION = gql`
  subscription OnFiendRequestCreated {
    friendRequestCreated {
      id
      sender {
        id
        username
        avatar
      }
      receiver {
        id
        username
        avatar
      }
      senderId
      receiverId
      accepted
      createdAt
      updatedAt
    }
  }
`;

export const ACCEPT_FRIEND_REQUEST_SUBSCRIPTION = gql`
  subscription OnFiendRequestAccepted {
    acceptedFriendRequest {
      id
      sender {
        id
        username
        avatar
      }
      receiver {
        id
        username
        avatar
      }
      senderId
      receiverId
      accepted
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_FRIEND_SUBSCRIPTION = gql`
  subscription OnFriendDeleted {
    deletedFriend {
      id
      receiverId
      senderId
      sender {
        id
        username
        avatar
      }
      receiver {
        id
        username
        avatar
      }
      createdAt
      updatedAt
    }
  }
`;
